'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var nthHookLoma = require('@narvar/nth-hook-loma');

const useEligibilityQuery = _ref => {
  let {
    onError,
    onCompleted
  } = _ref;
  const [getClaimEligibility, {
    loading,
    called,
    error
  }] = nthHookLoma.useGetClaimEligibilityAgentLazyQuery({
    fetchPolicy: 'network-only',
    onError,
    onCompleted: data => {
      onCompleted(data.claimEligibilityAgent);
    }
  });
  return [getClaimEligibility, {
    loading,
    called,
    error
  }];
};

exports["default"] = useEligibilityQuery;
